import type { MouseEvent } from "react";
import { quickFacts } from "@/mocks/movieContent";

const jumpChips = [
  { id: "plot", label: "剧情介绍", icon: "ri-book-open-line" },
  { id: "review", label: "影评解读", icon: "ri-chat-quote-line" },
  { id: "explain", label: "讲什么", icon: "ri-question-line" },
  { id: "impressions", label: "观后感", icon: "ri-emotion-line" },
];

export default function HeroSection() {
  const go = (id: string) => (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20abstract%20interior%20of%20an%20old%20movie%20theater%20with%20rows%20of%20empty%20red%20velvet%20seats%20glowing%20in%20warm%20amber%20projector%20light%2C%20dusty%20air%2C%20deep%20shadows%2C%20nostalgic%20atmosphere%2C%20warm%20amber%20and%20deep%20red%20color%20grading%2C%20soft%20film%20grain%2C%20moody%20low-key%20lighting%2C%20editorial%20photography%2C%20elegant%20and%20atmospheric&width=1600&height=900&seq=hap-hero-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/60 to-foreground-950/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 via-transparent to-foreground-950/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 md:px-8 pt-28 md:pt-36 pb-14 md:pb-20">
        <div className="hap-reveal max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/20 text-accent-200 text-xs md:text-sm font-label font-medium tracking-wide">
            <i className="ri-film-line"></i>
            影视信息 · 影评解说整理
          </span>
          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            姐姐的朋友电影
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-100/90 leading-relaxed max-w-2xl">
            这里集中整理这部影片的<strong className="font-semibold text-background-50">影评</strong>与
            <strong className="font-semibold text-background-50">解说</strong>，用一段话讲清它
            <strong className="font-semibold text-background-50">到底讲了什么</strong>，并补充
            <strong className="font-semibold text-background-50">剧情介绍</strong>与
            <strong className="font-semibold text-background-50">观后感</strong>，帮助你快速了解这部作品。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#plot"
              onClick={go("plot")}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              <i className="ri-book-open-line"></i>
              阅读剧情介绍
            </a>
            <a
              href="#review"
              onClick={go("review")}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-100/40 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/10"
            >
              <i className="ri-chat-quote-line"></i>
              查看影评解读
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-2">
            {jumpChips.map((chip) => (
              <a
                key={chip.id}
                href={`#${chip.id}`}
                onClick={go(chip.id)}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/10 text-background-100 text-xs md:text-sm cursor-pointer transition-colors hover:bg-background-50/20"
              >
                <i className={chip.icon}></i>
                {chip.label}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {quickFacts.map((fact, index) => (
            <div
              key={fact.label}
              className="hap-reveal rounded-lg border border-background-50/15 bg-foreground-950/40 backdrop-blur px-4 py-4"
              style={{ animationDelay: `${120 + index * 90}ms` }}
            >
              <div className="flex items-center gap-2 text-accent-300">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500/15">
                  <i className={`${fact.icon} text-base`}></i>
                </span>
                <span className="text-xs text-background-200/80 font-label">{fact.label}</span>
              </div>
              <p className="mt-3 text-sm md:text-base text-background-50 font-medium leading-snug">{fact.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}